var _path, _path2, _path3, _g, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionCrossBuyColoredDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M14 19H20V5H14V19Z",
    fill: "#5714CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M13.4648 21H22V5C22 3.89543 21.1045 3 20 3H13.4648C13.8052 3.58835 14 4.27143 14 5H20L20 19H14C14 19.7286 13.8052 20.4117 13.4648 21Z",
    fill: "#5714CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4648 21H23C23.5523 21 24 20.5523 24 20V19H14C14 19.7286 13.8052 20.4117 13.4648 21Z",
    fill: "#5714CC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 17H18V15H14V17Z",
    fill: "#5714CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9H18V7H14V9Z",
    fill: "#5714CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 11H18V13H15V11Z",
    fill: "#5714CC"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5H10V19H2V5Z",
    fill: "#FFC30D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16C4.44772 16 4 16.4477 4 17C4 17.5523 4.44772 18 5 18H7C7.55228 18 8 17.5523 8 17C8 16.4477 7.55228 16 7 16H5Z",
    fill: "#5714CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 3.89543 0.895431 3 2 3H10C11.1046 3 12 3.89543 12 5V19C12 20.1046 11.1046 21 10 21H2C0.895431 21 0 20.1046 0 19V5ZM2 5H10V19H2V5Z",
    fill: "#5714CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionCrossBuyColoredDay);
export default __webpack_public_path__ + "static/media/ic_action_cross_buy_colored_day.2035988fe7f5043e088b68bdab7ca213.svg";
export { ForwardRef as ReactComponent };